import { useState, useEffect } from "react";

const LiveClock = ({ textsize }) => {
  // Reloj en vivo
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timerId = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(timerId);
  }, []);

  return (
    <span
      className={`font-poppins font-bold w-[70px] text-nowrap ${
        textsize ? textsize : ""
      }`}
    >
      {time.toLocaleTimeString()}
    </span>
  );
};
export default LiveClock;
